import template from './insurance.template.html';

export default {
  template,
  bindings: {
    insurance: '<',
    assets: '<',
    contacts: '<',
    isTicketSettled: '<',
    onFinished: '&'
  },
controller: class controller {
    constructor($rootScope, helperService, dateTimeService) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.currentOrganization = $rootScope.CurrentOrganization;
      ctrl.currentCurrency = $rootScope.CurrentCurrency();
      ctrl.currentDateFormat = $rootScope.CurrentDateFormatPrimary();
      ctrl.organizationCountry = '';
      ctrl.availablePaymentFrequencies = [];

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      ctrl.initialize = () => {
        ctrl.organizationCountry = helperService.getOrganizationCountry().name;
        ctrl.availablePaymentFrequencies = helperService.getAvailablePaymentFrequencies({
          isExpense: false
        });
        ctrl.insurance = ctrl.insurance || {};
        ctrl.assets = ctrl.assets || [];
        ctrl.contacts = ctrl.contacts || [];
        ctrl.isTicketSettled = ctrl.isTicketSettled || false;
        dateTimeService.getSet(ctrl, ctrl.insurance, 'renewalDate', 'getSetRenewalDate');
      };

      ctrl.getAvailableAssetsForInsurance = (insurance) => {
        let assets = [];
        if (insurance.isInsuranceHomeContents()) {
          assets = _.filter(ctrl.assets, (a) =>
            helperService.isAssetTypeOwnerOccupiedOrInvestment(a.assetType)
          );
        }
        if (
          insurance.isInsuranceVehicle() ||
          insurance.isInsuranceMotorWarrantyProducts() ||
          insurance.isInsuranceGap()
        ) {
          assets = _.filter(ctrl.assets, (a) => helperService.isAssetTypeVehicle(a.assetType));
        }
        return assets;
      };

      /*
       * Save insurance
       * --------------------------------------------------------------------------------
       */
      ctrl.saveInsurance = () => {
        ctrl.onFinished({ insurance: ctrl.insurance });
      };

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      ctrl.$onInit = () => {
        ctrl.initialize();
      };
    }
  }
};
